module.exports = __webpack_public_path__ + "84d71164bfd0639ecca794e327ed74d6.svg";